
export default function actionAddCart(product, price, quantity, isSilent = false) {
  return async(dispatch) => {
    try {
      dispatch({
        type: 'ADD_CART_BEGIN'
      })
      
      const response = { message: '' }
      const result = await localStorage.getItem('nabawi-cart')
      const payload = (result)? JSON.parse(result) : []
      const indexExists = await payload.findIndex((item) => item.product.id === product.id)

      if(indexExists > -1) {
        payload[indexExists].quantity = payload[indexExists].quantity + quantity
        payload[indexExists].price = price
        payload[indexExists].normal_price = product.price
        payload[indexExists].discount = product.discount
        response.message = 'Produk sudah ditambahkan ke keranjang.'
      } else {
        payload.push({
          product: product,
          price: price,
          quantity: quantity,
          normal_price: product.price,
          discount: product.discount
        })
        response.message = 'Berhasil menambahkan ke keranjang.'
      }
      
      localStorage.setItem('nabawi-cart', JSON.stringify(payload))

      const successAction = {
        type: 'ADD_CART_SUCCESS',
        payload: payload
      }

      if (!isSilent) {
        successAction.success = response
      }

      dispatch(successAction)
    } catch (err) {
      dispatch({
        type: 'ADD_CART_FAILURE'
      })
    }
  }
}